import React from 'react'
import { Link } from 'react-router-dom'
import { dateIndo } from 'src/helper/date'

const CardArticle = ({
  type = 'vertical',
  highlight = false,
  size = 'normal', 
  slug,
  publishedAt = '2023-01-01',
  title = 'Title blm ada isi',
  image = '/images/articles/2.png',
}) => {
  const Img = ({ className = '', alt }) => (
    <img
      className={`w-full h-full object-cover ${className}`}
      src={image}
      alt={alt || title}
      loading="lazy"
      decoding="async"
    />
  )

  const Meta = ({ light = false }) => (
    <div
      className={[
        'text-xs md:text-sm tracking-wide',
        light
          ? 'text-white/90'
          : 'text-slate-500 group-hover:text-white/90 transition-colors'
      ].join(' ')}
    >
      <span className={light ? 'text-white/90' : 'text-[#2E7462] group-hover:text-white/90'}>
        AMS
      </span>
      <span className="mx-2">|</span>
      <span>{dateIndo(publishedAt)}</span>
    </div>
  )

  if (type === 'vertical') {
    return (
      <Link
        to={slug}
        className="
          group relative block rounded-2xl overflow-hidden
          ring-1 ring-slate-200
          hover:bg-[#2E7462] hover:shadow-lg
          transition-all duration-300
        "
      >
        <div
          className={
            size === 'hero'
              ? 'relative h-full min-h-[420px]'   
              : 'relative aspect-video'
          }
        >
          <Img />
          {highlight && (
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f1d]/70 via-[#0b1f1d]/20 to-transparent" />
          )}
        </div>

        {/* CONTENT */}
        <div
          className={
            size === 'hero'
              ? 'relative p-6 md:p-8 bg-[#2E7462] text-white'
              : 'p-4 md:p-6 transition-all duration-300 group-hover:bg-[#006c63]'
          }
        >
          <Meta light={size === 'hero'} />

          <div className="mt-2 mb-3 h-px bg-white/20" />

          <p
            className={
              size === 'hero'
                ? 'line-clamp-3 font-semibold text-[22px] md:text-[24px]'
                : 'line-clamp-2 font-semibold text-[18px] md:text-[21px] text-[#006c63] group-hover:text-white'
            }
          >
            {title}
          </p>
        </div>

        {size === 'hero' && (
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#2E7462] via-[#23bb86] to-[#006c63]" />
        )}
      </Link>
    )
  }

  return (
    <Link
      to={slug}
      className="
        group relative flex items-stretch
        rounded-2xl overflow-hidden
        ring-1 ring-slate-200
        hover:bg-[#2E7462] hover:shadow-lg
        transition-all duration-300
        h-32 md:h-36
      "
    >
      <div className="shrink-0 w-32 md:w-40">
        <Img />
      </div>

      <div className="flex-1 p-3 md:p-5 transition-all duration-300 group-hover:bg-[#2E7462]">
        <Meta />

        <div className="mt-2 mb-2 h-px bg-slate-200/70 group-hover:bg-white/20" />

        <p className="line-clamp-3 font-semibold text-[16px] md:text-[18px] text-[#2E7462] group-hover:text-white">
          {title}
        </p>
      </div>
    </Link>
  )
}

export default CardArticle
